<template>
    <el-dialog title="完善你的艺人信息" :visible="visible" class="form-dialog" :append-to-body="true" @open="onOpen"
        @update:visible="updateDialogVisible" center width="580px">
        <el-form ref="saveForm" :model="formData" :rules="rules" label-position="left" label-width="140px">
            <el-form-item prop="artistName" label="艺人名称" :rules="[{ required: true, message: '请填写艺名' }]">
                <el-input v-model="formData.artistName" placeholder=""></el-input>
                <p class="color-danger" style="position: absolute;right: 20px;top: 2px;">填写后不可修改</p>
            </el-form-item>
            <el-form-item label="性别/类型" prop="gender" :rules="[{ required: true, message: '请选择性别类型' }]">
                <el-select v-model="formData.gender" :filterable="true" placeholder="请选择">
                    <el-option v-for="item in genderOptions" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="头像" prop="logo" :rules="[{ required: true, message: '请上传音乐人/乐队照片' }]">
                <ImageUpload class="horizontal min" :url.sync="formData.logo" accept="image/png,image/jpeg" :size="10"
                    :minWidth="400" :minHeight="400" :circle="50" :drag="false"></ImageUpload>
            </el-form-item>
            <el-form-item prop="desc" label="简介">
                <el-input v-model="formData.desc" type="textarea" placeholder="简介" :rows="2"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="updateDialogVisible">取消</el-button>
                <el-button type="primary" :loading="saveLoading" @click="save">保存</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import ImageUpload from '@/components/ImageUpload';
    const defaultFormData = {
        artistName: '',
        gender: '',
        logo: '',
        desc: '',
    };
    export default {
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
        },
        components: { ImageUpload },
        data() {
            return {
                isFocus: false,
                formData: { ...defaultFormData },
                rules: {},
                saveLoading: false,
                genderOptions: [
                    { label: '未知', value: 0 },
                    { label: '男', value: 1 },
                    { label: '女', value: 2 },
                    { label: '组合', value: 3 },
                    { label: '乐队', value: 4 },
                    { label: '其他', value: 5 },
                ],
            };
        },
        methods: {
            onOpen() {
                this.formData = { ...defaultFormData };
            },
            updateDialogVisible() {
                this.$emit('update:visible', false);
            },
            save() {
                this.$refs['saveForm'].validate(async (valid) => {
                    if (!valid) return;
                    this.saveLoading = true;
                    const response = await this.$request({
                        url: '/org/artist/first_add',
                        method: 'POST',
                        params: this.formData,
                    });
                    const { state, msg } = response.data;
                    this.saveLoading = false;
                    if (!state) return this.$message.error(msg);
                    await this.$store.dispatch('getUserInfo');
                    this.$message.success('更新成功');
                    const { artistId } = this.$store.state.userInfo;
                    this.$emit('add-success', {
                        artistId: artistId,
                        artistName: this.formData.artistName,
                    });
                    this.updateDialogVisible();
                });
            },
        },
    };
</script>
<style lang="scss">
    // @keyframes inputFocus {
    //     from {
    //         font-size: 14px;
    //         top: 10px;
    //     }

    //     to {
    //         font-size: 12px;
    //         top: -9px;
    //     }
    // }

    // .user-artist {
    //     position: relative;
    //     border-bottom: 1px solid #dcdfe6;

    //     &::before {
    //         content: '填写后，艺名无法修改';
    //         height: 17px;
    //         padding: 0 5px;
    //         font-size: 14px;
    //         font-weight: 400;
    //         color: #909399;
    //         line-height: 17px;
    //         background: #fff;
    //         position: absolute;
    //         top: 10px;
    //         left: 15px;
    //         z-index: 0;
    //     }

    //     &.focus {
    //         border: 1px solid #dcdfe6;
    //         border-radius: 4px;

    //         &::before {
    //             animation: inputFocus 0.3s ease-out forwards;
    //         }
    //     }

    //     input.el-input__inner {
    //         border: none;
    //         border-radius: 0px;
    //         background: transparent;
    //         position: relative;
    //         z-index: 1;
    //     }
    // }
</style>
